import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, FlexibleModal, TextInput } from 'components'

const CreateGroupModal = ({ onCancel, onSubmit }) => {
  const { t } = useTranslation()
  const [form, setForm] = useState({})

  return (
    <FlexibleModal size="modal-md" visible={true}>
      <div className="flex flex-col space-y-4">
        <div className="flex flex-col space-y-4">
          <label className="flex justify-between">
            <p className="my-auto">Name</p>
            <TextInput
              className="w-2/3"
              onChange={(e) => setForm((f) => ({ ...f, Name: e.target.value }))}
              value={form.Name}
            />
          </label>
          <label className="flex justify-between">
            <p className="my-auto">SID</p>
            <TextInput
              className="w-2/3"
              onChange={(e) => setForm((f) => ({ ...f, SID: e.target.value }))}
              value={form.SID}
            />
          </label>
        </div>
        <div className="flex flex-row justify-end space-x-4">
          <Button
            className="border border-red-200 bg-white text-red-500 hover:border-red-500 hover:bg-red-500 hover:text-white"
            onClick={onCancel}
          >
            {t('application:cancel')}
          </Button>
          <Button
            className="bg-green-400 text-white hover:bg-green-500"
            onClick={(e) => onSubmit(form)}
          >
            {t('application:submit')}
          </Button>
        </div>
      </div>
    </FlexibleModal>
  )
}

export default CreateGroupModal
